(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accountpages-sidebar"] && !Shopify.designMode) return;
  try {
    const toggleBtn = document.getElementById('toggleSidebarAccountV2');
        const sidebar = document.querySelector('.sidebarAccountV2');
        const overlay = document.querySelector('.overlayAccountV2');
        const mobileArrow = document.querySelector('.sidebarAccountV2-mobilearrow');

        // Abrir/Cerrar con el botón
        toggleBtn.addEventListener('click', () => {
            sidebar.classList.toggle('openAccountV2');
            overlay.classList.toggle('showAccountV2');
        });
        // Abrir/Cerrar con la flecha móvil
        if (mobileArrow) {
            mobileArrow.addEventListener('click', () => {
                sidebar.classList.toggle('openAccountV2');
                overlay.classList.toggle('showAccountV2');
            });
        }
        // Cerrar al hacer clic en el overlay
        overlay.addEventListener('click', () => {
            sidebar.classList.remove('openAccountV2');
            overlay.classList.remove('showAccountV2');
        });
        // Cerrar al hacer clic fuera de la sidebar
        document.addEventListener('click', (event) => {
            if (
                sidebar.classList.contains('openAccountV2') &&
                !sidebar.contains(event.target) &&
                !toggleBtn.contains(event.target) &&
                !mobileArrow.contains(event.target)
            ) {
                sidebar.classList.remove('openAccountV2');
                overlay.classList.remove('showAccountV2');
            }
        });

        // Mobile swipe gestures
        let touchStartX = null;
        let touchEndX = null;
        function handleGesture() {
            if (touchStartX !== null && touchEndX !== null) {
                const diff = touchEndX - touchStartX;
                // Swipe right to open
                if (diff > 50) {
                    sidebar.classList.add('openAccountV2');
                    overlay.classList.add('showAccountV2');
                }
                // Swipe left to close
                if (diff < -50) {
                    sidebar.classList.remove('openAccountV2');
                    overlay.classList.remove('showAccountV2');
                }
            }
            touchStartX = null;
            touchEndX = null;
        }
        document.addEventListener('touchstart', function(e) {
            if (e.touches.length === 1) {
                touchStartX = e.touches[0].clientX;
            }
        });
        document.addEventListener('touchend', function(e) {
            if (e.changedTouches.length === 1) {
                touchEndX = e.changedTouches[0].clientX;
                handleGesture();
            }
        });
  } catch(e) { console.error(e); }
})();

})();
